var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospitality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 18.75H3C2.175 18.75 1.5 18.075 1.5 17.25C1.5 9.81 7.56 3.75 15 3.75C22.44 3.75 28.5 9.81 28.5 17.25C28.5 18.075 27.825 18.75 27 18.75ZM4.605 15.75H25.395C24.66 10.665 20.28 6.75 15 6.75C9.72 6.75 5.34 10.665 4.605 15.75Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 24H1.5C0.675 24 0 23.325 0 22.5C0 21.675 0.675 21 1.5 21H28.5C29.325 21 30 21.675 30 22.5C30 23.325 29.325 24 28.5 24Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3H13.5C12.675 3 12 2.325 12 1.5C12 0.675 12.675 0 13.5 0H16.5C17.325 0 18 0.675 18 1.5C18 2.325 17.325 3 16.5 3Z",
    fill: "#6C757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.37455C14.175 6.37455 13.5 5.69955 13.5 4.87455V1.97955C13.5 1.15455 14.175 0.479553 15 0.479553C15.825 0.479553 16.5 1.15455 16.5 1.97955V4.87455C16.5 5.69955 15.825 6.37455 15 6.37455Z",
    fill: "#6C757D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.455C14.175 22.455 13.5 21.78 13.5 20.955V18.06C13.5 17.235 14.175 16.56 15 16.56C15.825 16.56 16.5 17.235 16.5 18.06V20.955C16.5 21.78 15.825 22.455 15 22.455Z",
    fill: "#6C757D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitality);
export default __webpack_public_path__ + "static/media/hospitality.b0dd9f9348ea766e12be953af4b1a03d.svg";
export { ForwardRef as ReactComponent };